
import cfg from '../Config.js';

/**
 * A wrapper for local storage operations related to Cleeng data. This service provides methods to read Cleeng publisher, order, and customer IDs from local storage and return them as an object. 
 * It also includes a generic method to get any item from local storage by key.
 */
class localstorage_wrapper_svc {
    /**
     * Read from local storage Cleeng publisher, order and customer IDs and return them as an object. 
     * If publisher ID is not present, return an empty object.
     * @returns
     */
    get_cleeng_storage_data() {
        //cleeng storage data format publisherid_CLEENG_OFFER_ID, publisherid_CLEENG_OFFER_TYPE, publisherid_CLEENG_CUSTOMER_ID
        const data = { cleeng_offer_id: null, cleeng_order_id: null, cleeng_customer_id: null };
        if (!cfg.cleeng.publisher_id) {
            return data;
        }
        data.cleeng_offer_id = window.localStorage.getItem(`${cfg.cleeng.publisher_id}_CLEENG_OFFER_ID`);
        data.cleeng_order_id = window.localStorage.getItem(`${cfg.cleeng.publisher_id}_CLEENG_ORDER_ID`);
        data.cleeng_customer_id = window.localStorage.getItem(`${cfg.cleeng.publisher_id}_CLEENG_CUSTOMER_ID`);
        return data;
    }

    get(key) {
        if (!key) {
            return null;
        }
        return window.localStorage.getItem(key);
    }

    set(key, value) {
        if (!key) {
            return;
        }
        window.localStorage.setItem(key, value);
    }
    /**
     * Get any item from local storage by key, prefixing it with the Cleeng publisher ID. 
     * This method is useful for retrieving Cleeng-related data that is stored with a key that includes the publisher ID as a prefix.
     * @param {any} key
     * @returns
     */
    get_cleeng_property(key) {
        return window.localStorage.getItem(`${cfg.cleeng.publisher_id}_${key}`);
    }
}
export const localstorage_wrapper = new localstorage_wrapper_svc();